import React, { createContext, useContext, useState } from 'react';

export type OrderMode = 'dine_in' | 'delivery' | 'pickup';

export interface DeliveryInfo {
  name: string;
  street: string;
  postcode: string;
  city: string;
  phone: string;
  notes: string;
}

export interface PickupInfo {
  name: string;
  phone: string;
  pickupTime: string; // e.g. "ASAP" or "18:30"
  notes: string;
}

interface OrderContextType {
  mode: OrderMode;
  setMode: (m: OrderMode) => void;
  tableNumber: string;
  setTableNumber: (n: string) => void;
  deliveryInfo: DeliveryInfo;
  setDeliveryInfo: (info: DeliveryInfo) => void;
  pickupInfo: PickupInfo;
  setPickupInfo: (info: PickupInfo) => void;
}

const defaultDelivery: DeliveryInfo = { name: '', street: '', postcode: '', city: '', phone: '', notes: '' };
const defaultPickup: PickupInfo = { name: '', phone: '', pickupTime: 'ASAP', notes: '' };

const OrderContext = createContext<OrderContextType>({
  mode: 'delivery',
  setMode: () => {},
  tableNumber: '0',
  setTableNumber: () => {},
  deliveryInfo: defaultDelivery,
  setDeliveryInfo: () => {},
  pickupInfo: defaultPickup,
  setPickupInfo: () => {},
});

export const OrderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<OrderMode>('delivery');
  const [tableNumber, setTableNumber] = useState('0');
  const [deliveryInfo, setDeliveryInfo] = useState<DeliveryInfo>(defaultDelivery);
  const [pickupInfo, setPickupInfo] = useState<PickupInfo>(defaultPickup);

  return (
    <OrderContext.Provider value={{
      mode, setMode,
      tableNumber, setTableNumber,
      deliveryInfo, setDeliveryInfo,
      pickupInfo, setPickupInfo,
    }}>
      {children}
    </OrderContext.Provider>
  );
};

export const useOrder = () => useContext(OrderContext);
